// Mirrors CLIENT_API_SUBMITTED_STATUSES — partner-register rejects PATCH once any of these is set.
// https://github.com/qonto-private/partner-register/blob/master/app/models/registration.rb#L90-L96
export const SUBMITTED_STATUSES = [
  'submitted',
  'capital_deposit_activated',
  'capital_deposit_request_signed',
  'capital_deposit_certificate_signed',
  'completed',
];
